import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=033df477&scoped=true"
import script from "./ActivityItem.vue?vue&type=script&lang=js"
export * from "./ActivityItem.vue?vue&type=script&lang=js"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=033df477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033df477",
  null
  
)

export default component.exports